import { useParams } from "react-router-dom"

function useIdParam() {
  const { id } = useParams<{ id: string }>()
  return id && parseInt(id) ? parseInt(id) : null
}

export default useIdParam
